import { render, staticRenderFns } from "./DriverItems.vue?vue&type=template&id=f8292906&"
import script from "./DriverItems.vue?vue&type=script&lang=js&"
export * from "./DriverItems.vue?vue&type=script&lang=js&"
import style0 from "./DriverItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports